export default "__VITE_ASSET__CWvY9WXU__"